import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Dropdown as SemanticDropdown, Label } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import commonPropTypes from '../../../constants/commonPropTypes';
import { formFieldWrapper } from '../formFieldWrapper';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const renderLabelCondensed = (isOpen, remaining, renderLabel, item, index, defaultProps) => {
    if (index === 0 || isOpen) {
        return renderLabel
            ? renderLabel(item, index, defaultProps)
            : SemanticDropdown.defaultProps.renderLabel(item, index, defaultProps);
    }
    if (index === 1) {
        return _jsxs(Label, { className: cx('more-label'), children: [remaining, " More..."] });
    }
    return null;
};
const Select = ({ elmId, placeholder, fluid, label, renderLabel, condensedWhenClosed, onOpen, onClose, value, showError, multiple, ...rest }) => {
    const [isOpen, setOpen] = useState(false);
    const onOpenEx = (event, data) => {
        setOpen(true);
        onOpen(event, data);
    };
    const onCloseEx = (event, data) => {
        setOpen(false);
        onClose(event, data);
    };
    const remaining = value?.length > 1 ? value.length - 1 : null;
    if (typeof value === 'undefined' && multiple) {
        value = [];
    }
    return (_jsx(SemanticDropdown, { className: cx({ condensed: !isOpen && condensedWhenClosed && remaining }), selection: true, "data-elm-id": `${elmId}_select`, placeholder: placeholder || label, fluid: fluid, renderLabel: condensedWhenClosed
            ? renderLabelCondensed.bind(null, isOpen, remaining, renderLabel)
            : renderLabel, onOpen: onOpenEx, onClose: onCloseEx, error: showError, multiple: multiple, value: value, ...rest }));
};
Select.defaultProps = {
    fluid: true,
    options: [],
    onOpen: _.noop,
    onClose: _.noop,
};
Select.propTypes = {
    ...commonPropTypes,
    options: PropTypes.array,
    condensedWhenClosed: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
};
export default formFieldWrapper((fieldProps, showError) => (_jsx(Select, { ...fieldProps, showError: showError })));
//# sourceMappingURL=index.js.map